import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { secondary } from "./Header.module.scss";

const SecondaryTitle = ({ component: Component, className, ...props }) => (
  <Component className={classNames(secondary, className)} {...props} />
);

SecondaryTitle.propTypes = {
  /**
    Set the component's tag, can be an HTML element, or a React element
  */
  component: PropTypes.elementType,
  className: PropTypes.string
};

SecondaryTitle.defaultProps = {
  component: "span",
  className: ""
};

export default SecondaryTitle;
